<template>
    <div class="unauthorized row justify-content-center align-items-center">
        <div class="unauthorized__filter"></div>
        <div class="unauthorized__container col-11 col-md-6">
            <div class="unauthorized__header">
                <div class="unauthorized__logo">
                    <img src="../../assets/icons/icon-128x128.png" alt="Opt-Outs Logo">
                </div>
                Opt-Outs
            </div>
            <div class="unauthorized__sub-header">
                To access the Opt-Outs application, you must sign in to the myKing's Student Portal.
            </div>
            <div class="unauthorized__deadlines">
                <h5>Important Information</h5>
                <ul>
                    <li>
                        For students starting in September, the submission deadline is September 23, 2025.
                    </li>
                    <li>
                        The deadline for the Orientation Week opt-out for first year students is August 15, 2025.
                    </li>
                    <li>
                        Health and Dental plan opt out is available at <a
                            href="https://www.mystudentplan.ca/purplecare/en/home" target="_blank">www.purplecare.ca</a>
                        deadline September 23, 2025.
                    </li>
                </ul>
            </div>
            <div class="unauthorized__menu">
                <a :href="studentPortal" class="btn btn-default">Sign In to Student Portal</a>
            </div>
        </div>
        <div class="unauthorized__staff-message">
            Staff members, please authenticate via <a :href="staffPortal">myKing's</a>
        </div>
    </div>
</template>

<script>
export default {
    name: 'unauthorized',
    data() {
        return {
            studentPortal: '',
            staffPortal: ''
        }
    },
    created() {
        // Generate redirect URL to Student Portal
        let URL = 'https://HOSTNAME/cgi-bin/mkvn/app.pl?ROLE&redirect=1';
        
        URL = URL.replace("HOSTNAME", location.hostname);
        
        // Set student portal URL        
        this.studentPortal = URL.replace("ROLE", "student");

        // Set student portal URL        
        this.staffPortal = URL.replace("ROLE", "staff");
    }
}
</script>

<style scoped>
.unauthorized {
    background: url('../../assets/background/unauthorized.jpg') no-repeat center center fixed;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    color: #fff;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    min-width: 100%;
    min-height: 100%;
    margin: 0;
}

.unauthorized__container {
    background-color: rgba(0,0,0,.8);
    border-radius: 18px;
    padding: 2rem;
    text-align: center;
    z-index: 997;
}

.unauthorized__deadlines {
    font-size: 1rem;
    text-align: left !important;
}

.unauthorized__filter {
    /* background: linear-gradient(0deg,rgba(0,0,0,.5),rgba(255,255,255,0)); */
    background: #000;
    opacity: .45;
    display: block;
    position: absolute;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
}

.unauthorized__header {
    font-size: 2rem;
    line-height: 1.1;
    margin-bottom: 1.5rem;
}

.unauthorized__logo {
    margin-bottom: 1rem;
}

.unauthorized__logo img {
    height: 64px;
}

.unauthorized__menu {
    text-align: center;
}

.unauthorized__sub-header {
    font-size: 1.25rem;
    line-height: 1.2;
    margin-bottom: 2rem;
}

.unauthorized__staff-message {
    position: absolute;
    bottom: 10px;
    right: 0;
    margin-right: 10px;
    right: 0;
    padding: 4px 8px;
    background-color: rgba(0,0,0,1);
    border-radius: 1rem;
}

.unauthorized__staff-message a  {
    color: #007bff;
}
</style>
